import api from "./index";

export const reportsAPI = {
  getProjectCost: (id) => api.get(`/reports/project-cost/${id}`),
  getLabor: (projectId, params) =>
    api.get(`/reports/labor/${projectId}`, { params }),
  getMaterial: (projectId, params) =>
    api.get(`/reports/material/${projectId}`, { params }),
  getProgress: (projectId) => api.get(`/reports/progress/${projectId}`),
};
